import React, { useState, Fragment } from "react";
import Navbarsticky from "./NavbarSticky";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";

const emptyPassenger = (i = 1) => ({
  sno: i,
  title: "MR",
  name: "",
  gender: "Male",
  age: "",
  nationality: "India",
  idNumber: "",
});

const titles = ["MR", "MRS", "MS", "MX"];
const genders = ["Male", "Female", "Other"];
const countries = [
  "India",
  "United States",
  "United Kingdom",
  "Australia",
  "Canada",
  "Singapore",
  "UAE",
];

export default function FerrySeatBooking() {


    const { state } = useLocation();

  const { sailing, selectedClass, search } = state;

  console.log("Sailing:", sailing);
  console.log("Selected Class:", selectedClass);
  console.log("Search:", search);



  const [gstin, setGstin] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [passengers, setPassengers] = useState([emptyPassenger(1)]);
  const [errors, setErrors] = useState({});

  const addRow = () => {
    setPassengers((p) => [...p, emptyPassenger(p.length + 1)]);
  };

  const updateRow = (index, key, value) => {
    setPassengers((p) =>
      p.map((row, i) => (i === index ? { ...row, [key]: value } : row))
    );
  };

  const validate = () => {
    const errs = {};

    if (email && !/^\S+@\S+\.\S+$/.test(email)) errs.email = "Invalid email";
    if (phone && !/^\d{10}$/.test(phone)) errs.phone = "Enter 10 digits";

    passengers.forEach((row, i) => {
      if (!row.name.trim()) errs[`name-${i}`] = "Required";
      if (!row.age || Number(row.age) <= 0) errs[`age-${i}`] = "Invalid";
    });

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      trip: {
        route: "Port Blair – Swaraj Dweep (1313)",
        date: "18 Sep 2025",
      },
      gstin: gstin || null,
      email: email || null,
      phone: phone || null,
      passengers,
    };

    console.log("Submitting payload:", payload);
    alert("Form submitted!");
  };

  return (
    <>
      <Navbarsticky />
      <div className="ferryseatbooking-container"></div>
      <div className="pf-wrap">
        {/* TRIP CARD */}
        <div className="pf-card pf-trip">
          <span className="pf-check">✓</span>
          <div className="pf-route">{search.source} – {search.destination} ( 1313 )</div>
          <div className="pf-date">18 Sep 2025</div>
        </div>

        {/* FORM */}
        <form className="pf-card" onSubmit={onSubmit} noValidate>
          <h2 className="pf-heading">Enter Passengers Details</h2>

          {/* TOP GRID */}
          <div className="pf-grid pf-grid-2">
            <label className="pf-field">
              <span>GSTIN (Optional)</span>
              <input
                type="text"
                value={gstin}
                onChange={(e) => setGstin(e.target.value.toUpperCase())}
                placeholder="GSTIN (Optional)"
              />
            </label>

            <label className="pf-field">
              <span>Email</span>
              <input
                type="email"
                value={email}
                placeholder="EMAIL"
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <em className="pf-err">{errors.email}</em>}
            </label>

            <label className="pf-field pf-span-2">
              <span>Phone Number</span>
              <input
                type="tel"
                value={phone}
                placeholder="10 Digit Phone Number"
                maxLength={10}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/\D/g, ""))
                }
              />
              {errors.phone && <em className="pf-err">{errors.phone}</em>}
            </label>
          </div>

          {/* TABLE */}
          <div className="pf-table-wrap">
            <table className="pf-table">
              <thead>
                <tr>
                  <th>SNo</th>
                  <th>Title</th>
                  <th>Passenger Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Nationality</th>
                  <th>ID Number</th>
                </tr>
              </thead>

              <tbody>
                {passengers.map((row, i) => (
                  <tr key={i}>
                    <td className="pf-sno">{row.sno}</td>

                    <td>
                      <select
                        value={row.title}
                        onChange={(e) =>
                          updateRow(i, "title", e.target.value)
                        }
                      >
                        {titles.map((t) => (
                          <option key={t}>{t}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        type="text"
                        value={row.name}
                        placeholder="Name"
                        onChange={(e) =>
                          updateRow(i, "name", e.target.value)
                        }
                      />
                      {errors[`name-${i}`] && (
                        <em className="pf-err">{errors[`name-${i}`]}</em>
                      )}
                    </td>

                    <td>
                      <select
                        value={row.gender}
                        onChange={(e) =>
                          updateRow(i, "gender", e.target.value)
                        }
                      >
                        {genders.map((g) => (
                          <option key={g}>{g}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        type="number"
                        value={row.age}
                        min="0"
                        placeholder="Age"
                        onChange={(e) =>
                          updateRow(i, "age", e.target.value)
                        }
                      />
                      {errors[`age-${i}`] && (
                        <em className="pf-err">{errors[`age-${i}`]}</em>
                      )}
                    </td>

                    <td>
                      <select
                        value={row.nationality}
                        onChange={(e) =>
                          updateRow(i, "nationality", e.target.value)
                        }
                      >
                        {countries.map((c) => (
                          <option key={c}>{c}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        type="text"
                        value={row.idNumber}
                        placeholder="ID Number"
                        onChange={(e) =>
                          updateRow(i, "idNumber", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pf-row-actions">
              <button
                type="button"
                className="pf-btn-secondary"
                onClick={addRow}
              >
                + Add Passenger
              </button>
            </div>
          </div>

          {/* SUBMIT */}
          <div className="pf-submit">
            <button type="submit" className="pf-btn-submit">
              Submit
            </button>
          </div>
        </form>
      </div>

      <Footer />
    </>
  );
}
